/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, July 2020
 */

import {
  FlowBlock,
  FlowBlockRoot,
  FlowBlockPage,
  FlowBlockTerminalPage,
  FlowBlockWarningPage,
} from '@staffino/model';
import accept from './block-visitor';

export default class FlowDefinitionTraverser {
  private readonly pages: FlowBlockPage[];

  constructor(private readonly definition: FlowBlockRoot) {
    this.pages = definition.children.filter(
      (page) => page.type === 'page',
    ) as FlowBlockPage[];
  }

  getPageAt(index: number): FlowBlockPage {
    return this.pages[index] as FlowBlockPage;
  }

  getLastPage(): FlowBlockPage {
    return this.pages[this.pages.length - 1];
  }

  getPageById(id: string): FlowBlockPage {
    return this.pages.find((page) => page.id === id) as FlowBlockPage;
  }

  getPageIndex(page: FlowBlockPage): number {
    return this.pages.indexOf(page);
  }

  getSucceedingPage(page: FlowBlockPage): FlowBlockPage {
    const index = this.getPageIndex(page);
    return index === -1 ? undefined : this.getPageAt(index + 1);
  }

  getPreviousPage(page: FlowBlockPage): FlowBlockPage {
    const index = this.getPageIndex(page);
    return index <= 0 ? undefined : this.getPageAt(index - 1);
  }

  getTerminalPage(): FlowBlockTerminalPage {
    return this.definition.children.find(
      (page) => page.type === 'terminal-page',
    ) as FlowBlockTerminalPage;
  }

  getWarningPage(): FlowBlockWarningPage {
    return this.definition.children.find(
      (page) => page.type === 'warning-page',
    ) as FlowBlockWarningPage;
  }

  getBlockById(id: string): FlowBlock {
    let result = null;
    const visitor = {
      enter(block) {
        if (block.id === id) {
          result = block;
        }
      },
    };
    accept(this.definition, visitor);
    return result;
  }

  getBlocksByType(type: string): FlowBlock[] {
    const result = [];
    const visitor = {
      enter(block) {
        if (block.type === type) {
          result.push(block);
        }
      },
    };
    accept(this.definition, visitor);
    return result;
  }
}
